import { variant } from 'styled-system';

export const mode = variant({
  prop: 'mode',
  variants: {
    center: {
      top: '50%',
      transform: 'translate(0, -50%)',
    },
    withSpace: {
      top: 'sp-24',
    },
  },
});
